import style from '../article-page/article-page.module.scss';

type TableNavbarProps = {
    titles: string[];
    activeTitle: string;
    handler: (target: string) => void;
}

const TableNavbar = ({titles, handler, activeTitle}: TableNavbarProps) => {
    return (
        <>
            {titles.map((title, index) => {
                const activeClasses: string = activeTitle === title ? style.selected : '';
                return (
                    <span
                        key={title}
                        className={`${style.article__navigation__list__item} ${activeClasses}`}
                        id={title}
                        data-selected-title={!!activeClasses}
                        onClick={() => handler(title)}
                    >{index + 1}. {title}</span>
                );
            })}
        </>
    );
};

export default TableNavbar;
